"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _color = _interopRequireDefault(require("color"));

function _default(palette) {
  var primary = (0, _color["default"])(palette.tAccent);
  var hoverColor;
  hoverColor = primary.rotate(2);
  hoverColor = (0, _color["default"])(hoverColor).saturate(0.3);
  hoverColor = (0, _color["default"])(hoverColor).darken(0.2);
  hoverColor = hoverColor.rgb().string();
  return {
    palette: palette,
    display: 'inline',
    fontSize: palette.tsNormal,
    lineHeight: palette.tlNormal,
    fontFamily: palette.fontFamily,
    textAlign: 'left',
    textDecoration: 'none',
    fontWeight: palette.twNormal,
    color: palette.tInactive,
    transitionTimingFunction: palette.transitionFunction,
    transitionDuration: palette.transitionDuration,
    hoverTextDecoration: 'none',
    hoverColor: palette.tAccent,
    inTextColor: palette.tAccent,
    inTextTextDecoration: 'none',
    inTextHoverColor: hoverColor,
    inTextHoverTextDecoration: 'underline',
    width: 'auto',
    minWidth: 'auto'
  };
}